import CurrentUserStore from 'mewe/stores/current-user-store';
import ContactsApi from 'mewe/api/contacts-api';
import ProfileStore from 'mewe/stores/profile-store';
import { createDeferred } from 'mewe/shared/utils';

export default function ({ uuid = null, groupId, details = false } = {}) {
  const deferred = createDeferred();

  CurrentUserStore.getState().deferred.promise.then(() => {
    if (!uuid) {
      uuid = CurrentUserStore.getState().get('id');
    }

    ContactsApi.getUserDetails({ userId: uuid, groupId, details })
      .then((data) => {
        ProfileStore.send('handleRawData', data, groupId);
        deferred.resolve();
      });
  });

  // promise is returned in case we want to invoke code after profile is fetched
  return deferred.promise;
}
